export default {
  "HitPaw Online Audio Converter": "HitPaw在线音频转换器",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "免费将音频转换为MP3, AAC, FLAC, WMA等音视频格式。",
  'HitPaw Online Image Converter': 'HitPaw在线图片转换器',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': '免费将图片转换为JPG, PNG, BMP, TIFF等图片格式。',
  'HitPaw Online Video Converter': '在线视频转格式',
  'Convert videos to any formats as your requirements.': '在线视频转格式描述',
  'Add More Files': '添加更多文件',
  'Convert to': '转为',
  'Ready': '准备',
  'Converting': '转格式中',
  'Video': '视频',
  'Audio': '音频',
  'Image': '图片',
  'Retry': '重试',
  'Download All': '下载全部',
  'Download Desktop': '下载桌面端',
  'Continue Editing': '继续编辑',
  'Convert': '转格式',
  'Cut': '截取',
  'Speed': '变速',
  'Crop & Rotate': '裁剪&旋转',
  'Resize': '改变大小',
  'Extract': '提取音视频',
  'Add Music': '加音乐',
  'Subtitles': '加字幕',
  'Merge': '合并',
  'Watermark Remover': '去水印',
  'Add Watermark': '加水印',
  'Please select a file to use': '请选择一个文件去{{work}}',
  'Batch Processing': 'Batch Processing',
};
